exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-66dfcfe7],html[data-v-66dfcfe7]{padding:0;margin:0}#donePage[data-v-66dfcfe7]{background:var(--theme-color)}", ""]);

// exports
